import { useEffect, useState } from 'react'
import { Table } from 'antd'
import { totalModel } from './totalModel'
import { SettleDetail } from '../detail'
import YhTootip from '@/components/YhTootip'

export function DataTable() {

    const {
        dataSource, pgCfg, loading,
        loadData,
        selectedRowKeys, setSelectedRowKeys,
        franchiseeCode, setFranchiseeCode, setSelected,
    } = totalModel()

    useEffect(() => {
        loadData()
    }, [])

    // useEffect(() => {
    //     console.log(selectedRowKeys);
    // }, [selectedRowKeys])

    const columns: any[] = [
        {
            title: '序号',
            width: 40,
            align: 'center',
            dataIndex: '',
            render: (t, r, i) => i + 1,
        },
        {
            title: '加盟商名称',
            width: 160,
            align: 'center',
            dataIndex: 'franchiseeName',
            render: (text, r) => (
                <div
                    style={{ color: 'rgb(62, 103, 244)', cursor: 'pointer' }}
                    onClick={() => { setFranchiseeCode(r.franchiseeCode); setSelected(r); }}>
                    {text}
                </div>
            ),
        },
        {
            title: '工单数量',
            width: 150,
            align: 'center',
            dataIndex: 'orderCount',
            render: (text) => <YhTootip text={text} />,
        },
        {
            title: '账单金额',
            width: 150,
            align: 'center',
            dataIndex: 'orderTotalAmount',
            render: (text) => <YhTootip text={text} />,
        },
        {
            title: '出账开始日期',
            width: 150,
            align: 'center',
            dataIndex: 'fixedCreateTime',
            render: (text) => <YhTootip text={text} />,
        },
        {
            title: '出账结束日期',
            width: 150,
            align: 'center',
            dataIndex: 'fixedEndTime',
            render: (text) => <YhTootip text={text} style={{ width: '150px' }} />,
        }
    ]

    return (
        <>
            <Table
                rowKey={(record) => record.id}
                columns={columns}
                dataSource={dataSource}
                loading={loading}
                pagination={{
                    ...pgCfg,
                    position: ['bottomRight'],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                    showSizeChanger: true,
                }}
                bordered
                onRow={(record) => ({
                    onClick: () => setSelectedRowKeys([record.id]),
                    onContextMenu: (e) => {
                        e.preventDefault()
                        setSelectedRowKeys([record.id])
                    },
                })}
                scroll={{ x: 'max-content', y: 'calc(100vh - 470px)' }}
            />

            <SettleDetail code={franchiseeCode} setCode={setFranchiseeCode} />
        </>
    )
}
